import React from 'react';
import { Box, Flex, IconButton, Text } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

const SimplePagination = ({ currentPage, totalPages, onPageChange }) => {
    const handlePrevious = () => {
        if (currentPage > 1) {
            onPageChange(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            onPageChange(currentPage + 1);
        }
    };

    // Don't render pagination if there's only 1 page or no pages
    if (totalPages <= 1) {
        return null;
    }

    return (
        <Box mt={6} mb={4}>
            <Flex justifyContent="center" alignItems="center" gap={4}>
                <IconButton
                    aria-label="Previous page"
                    icon={<FontAwesomeIcon icon={faChevronLeft} />}
                    size="sm"
                    variant="ghost"
                    colorScheme="gray"
                    isDisabled={currentPage <= 1}
                    onClick={handlePrevious}
                    borderRadius="md"
                />

                <Text fontSize="sm" color="gray.600" fontWeight="medium" minW="80px" textAlign="center">
                    Page {currentPage} of {totalPages}
                </Text>

                <IconButton
                    aria-label="Next page"
                    icon={<FontAwesomeIcon icon={faChevronRight} />}
                    size="sm"
                    variant="ghost"
                    colorScheme="gray"
                    isDisabled={currentPage >= totalPages}
                    onClick={handleNext}
                    borderRadius="md"
                />
            </Flex>
        </Box>
    );
};

export default SimplePagination;